import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { FaEye, FaArrowLeft, FaShoppingBag, FaStar } from "react-icons/fa";
import { API_BASE_URL } from "../config/api";

const getProductImageUrl = (product) => {
  const imagePath =
    Array.isArray(product?.images) && product.images.length > 0
      ? product.images[0]
      : product?.image;

  if (!imagePath) return "https://via.placeholder.com/260x260?text=No+Image";

  const cleanPath = String(imagePath)
    .replace(/\\/g, "/")
    .replace(/^\/+/, "");

  if (cleanPath.startsWith("http")) return cleanPath;
  if (cleanPath.startsWith("uploads/")) return `${API_BASE_URL}/${cleanPath}`;

  return `${API_BASE_URL}/uploads/${cleanPath}`;
};

function CategoryPage() {
  const { category } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!category) return;
    loadProducts();
  }, [category]);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const schoolId = localStorage.getItem("schoolId");
      const res = await axios.post(`${API_BASE_URL}/uniform/filter`, {
        schoolId,
        sizeCategory: category
      });
      setProducts(res.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  return (
    <div className="premium-category-wrapper">
      {/* 🌟 Luxury Header Section */}
      <div className="category-banner">
        <div className="container">
          <button className="back-circle-btn" onClick={() => navigate(-1)}>
            <FaArrowLeft />
          </button>
          <div className="banner-content text-center">
            <span className="exclusive-tag">Exclusive Collection</span>
            <h1 className="main-cat-title">{category} Section</h1>
            <p className="cat-desc">Official premium quality uniforms curated for excellence.</p>
          </div>
        </div>
      </div>

      <div className="container py-5">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-luxury"></div>
          </div>
        ) : (
          <div className="row g-5">
            {products.length === 0 ? (
              <div className="text-center py-5">
                <img src="https://cdn-icons-png.flaticon.com/512/11502/11502442.png" width="120" alt="empty" />
                <h3 className="mt-4 text-muted">Aww! No items in this category yet.</h3>
                <button className="btn-explore" onClick={() => navigate(-1)}>Explore Others</button>
              </div>
            ) : (
              products.map((p) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={p._id}>
                  <div className="boutique-card">
                    <div className="image-container">
                      <img
                        src={getProductImageUrl(p)}
                        alt={p.name}
                        className="p-img"
                      />
                      {/* 🔥 Action Overlay like Parent Page */}
                      <div className="overlay-actions">
                        <button className="action-circle" onClick={() => navigate(`/uniform/${p._id}`)}>
                          <FaEye />
                        </button>
                        <button className="action-circle">
                          <FaShoppingBag />
                        </button>
                      </div>
                      <div className="rating-badge">
                        <FaStar /> 4.8
                      </div>
                    </div>

                    <div className="p-details text-center">
                      <span className="p-category">{p.sizeCategory}</span>
                      <h5 className="p-name">{p.name || "School Essential"}</h5>
                      <div className="p-price-row">
                        <span className="currency">₹</span>
                        <span className="price-val">{p.price}</span>
                      </div>
                      <button 
                        className="btn-view-boutique"
                        onClick={() => navigate(`/uniform/${p._id}`)}
                      >
                        VIEW DETAILS
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Plus+Jakarta+Sans:wght@300;500;700&display=swap');

        .premium-category-wrapper { background: #fdfdfd; min-height: 100vh; font-family: 'Plus Jakarta Sans', sans-serif; }

        /* Banner Design */
        .category-banner { 
          background: linear-gradient(rgba(9, 121, 105, 0.9), rgba(9, 121, 105, 0.95)), 
                      url('https://www.transparenttextures.com/patterns/cubes.png');
          padding: 80px 0; border-radius: 0 0 50px 50px; color: white; position: relative;
        }
        .exclusive-tag { background: #edf9f5; color: #097969; padding: 5px 15px; border-radius: 20px; font-size: 0.7rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; }
        .main-cat-title { font-family: 'Playfair Display', serif; font-size: 3.5rem; margin: 15px 0; }
        .back-circle-btn { position: absolute; left: 30px; top: 30px; border: 1px solid rgba(255,255,255,0.3); background: rgba(255,255,255,0.1); color: white; width: 45px; height: 45px; border-radius: 50%; transition: 0.3s; }
        .back-circle-btn:hover { background: white; color: #097969; transform: scale(1.1); }

        /* Boutique Card */
        .boutique-card { background: white; border-radius: 25px; overflow: hidden; transition: 0.4s ease; border: 1px solid #f0f0f0; position: relative; }
        .boutique-card:hover { transform: translateY(-12px); box-shadow: 0 25px 50px rgba(9, 121, 105, 0.12); }

        .image-container { position: relative; background: #f8fbfb; height: 260px; display: flex; align-items: center; justify-content: center; overflow: hidden; }
        .p-img { height: 85%; object-fit: contain; transition: 0.6s; }
        .boutique-card:hover .p-img { transform: scale(1.1); }

        /* Overlay */
        .overlay-actions { position: absolute; inset: 0; background: rgba(9, 121, 105, 0.2); display: flex; align-items: center; justify-content: center; gap: 15px; opacity: 0; transition: 0.3s; }
        .boutique-card:hover .overlay-actions { opacity: 1; }
        .action-circle { width: 45px; height: 45px; border-radius: 50%; border: none; background: white; color: #097969; display: flex; align-items: center; justify-content: center; transition: 0.3s; box-shadow: 0 10px 20px rgba(0,0,0,0.1); }
        .action-circle:hover { background: #097969; color: white; transform: scale(1.1); }

        .rating-badge { position: absolute; top: 15px; right: 15px; background: white; padding: 4px 10px; border-radius: 12px; font-size: 0.7rem; font-weight: 700; color: #ffac0e; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }

        /* Details */
        .p-details { padding: 25px 20px; }
        .p-category { font-size: 0.7rem; font-weight: 600; color: #097969; text-transform: uppercase; letter-spacing: 1px; }
        .p-name { font-weight: 700; color: #1e293b; margin: 8px 0; font-size: 1.1rem; }
        .p-price-row { margin-bottom: 20px; }
        .currency { font-size: 0.9rem; color: #097969; font-weight: 600; margin-right: 2px; }
        .price-val { font-size: 1.5rem; font-weight: 800; color: #1e293b; }

        .btn-view-boutique { width: 100%; border: 1.5px solid #097969; background: transparent; color: #097969; padding: 10px; border-radius: 12px; font-weight: 700; font-size: 0.75rem; letter-spacing: 1px; transition: 0.3s; }
        .btn-view-boutique:hover { background: #097969; color: white; box-shadow: 0 10px 20px rgba(9, 121, 105, 0.2); }

        /* Loader */
        .spinner-luxury { width: 50px; height: 50px; border: 5px solid #edf9f5; border-top: 5px solid #097969; border-radius: 50%; animation: spin 1s linear infinite; display: inline-block; }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        
        .btn-explore { background: #097969; color: white; border: none; padding: 12px 30px; border-radius: 30px; font-weight: 700; margin-top: 20px; transition: 0.3s; }
        .btn-explore:hover { opacity: 0.9; transform: scale(1.05); }
      `}</style>
    </div>
  );
}

export default CategoryPage;
